import React, { useState, useRef, useEffect } from "react";
import Modal from "../../../customComponents/CustomModal/CustomModal";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import ROUTES_NAVIGATION from "../../../../routes/routes";
import {
  toastError,
  toastSuccess,
} from "../../../customComponents/customToast/Toast";
import axiosInstance from "../../../services/api/API";
import { ToastContainer } from "react-toastify";
import Swal from "sweetalert2";

const ReusableTable = ({
  headers,
  data,
  keyMapping,
  itemsPerPage,
  currentPage,
  totalPages,
  totalRecords,
  onPageChange,
  isallocation,
  onEdit,
  isFollowUp,
  isLeadCalling,
  isFollowUpRequired,
  isOldLeadCalling,
  callListApi=()=>{}
}) => {
  //  const [currentPage, setCurrentPage] = useState(0);
  console.log("leaddata>>", data);
  const navigate = useNavigate();
  const [checkboxState, setCheckboxState] = useState(data.map(() => false));
  const [showModal, setShowModal] = useState(false);
  const [currentTelecallerId, setCurrentTelecallerId] = useState(null);
  const [selectedAssignee, setSelectedAssignee] = useState(0);
  const [assigneeList, setAssigneeList] = useState([
    // { name: 'Telecaller 1', assignedLeads: 5 },
    // { name: 'Telecaller 2', assignedLeads: 10 },
    // { name: 'Telecaller 3', assignedLeads: 3 },
    // { name: 'Sales Manager 1', assignedLeads: 8 },
    // { name: 'Sales Manager 2', assignedLeads: 6 },
    // { name: 'Sales Manager 3', assignedLeads: 2 },
  ]);
  //alert("hello")
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredAssigneeList, setFilteredAssigneeList] =
    useState(assigneeList);
  const [selectedLeadId, setSelectedLeadId] = useState(null);
  const assignButtonRef = useRef(null);
  const [modalPosition, setModalPosition] = useState({});
  const [moreActionsRowId, setMoreActionsRowId] = useState(null);
  const [modalType, setModalType] = useState(null);
  const authToken = localStorage.getItem("authToken");
  const businessPartnerId = localStorage.getItem("business_partner_id");

  //const totalPages = Math.ceil(data.length / itemsPerPage);

  useEffect(() => {
    if (modalType) {
      console.log("modalType", modalType);
      fetchAssigneeList();
    }
  }, [modalType]);

  const fetchAssigneeList = async () => {
    console.log("modalType>>", modalType);
    // try {
    //   const endpoint = modalType === 'Telecaller' ? '/user/ddltelecaller' : '/dealer/ddlDealer';
    //   const response = await axiosInstance.post(
    //     endpoint,
    //     { business_partner_id: businessPartnerId ==="0"?null:businessPartnerId},
    //     {
    //       headers: {
    //         "Content-Type": "application/json",
    //         Authorization: `Bearer ${authToken}`,
    //       },
    //     }
    //   );
    //   const assignees = response.data.data.data.map(assignee => ({
    //     name: assignee.NAME,
    //     id: assignee.ID,
    //     assignedLeads: assignee.assignedcount,
    //   }));
    //   setAssigneeList(assignees);
    //   console.log("assignees",assignees);
    //   setFilteredAssigneeList(assignees);
    //   //setModalType(null)
    //   console.log("filteredAssigneeList",filteredAssigneeList);
    // } catch (error) {
    //   const errorMessage = error.response?.data?.message || "Failed to fetch assignees. Please try again.";
    //   toastError(errorMessage);
    //   console.error("Error fetching assignees:", error);
    // }
  };

  const handlePreviousPage = () => {
    if (currentPage > 0) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages - 1) {
      onPageChange(currentPage + 1);
    }
  };

  const handlePageClick = (pageIndex) => {
    onPageChange(pageIndex);
  };

  const handleCheckboxChange = (index) => {
    console.log("checkboxstate", index);
    const updatedCheckboxState = [...checkboxState];
    updatedCheckboxState[index] = !updatedCheckboxState[index];
    setCheckboxState(updatedCheckboxState);
  };

  const handleAssignClick = () => {
    if (checkboxState.some((checked) => checked)) {
      const rect = assignButtonRef.current.getBoundingClientRect();
        setModalPosition({
          top: rect.top + window.scrollY - 100,
          left: rect.left + window.scrollX,
        });
      setShowModal(true);
    } else {
      //alert("Please select at least one row to assign.");
    }
  };

  const handleModalClose = () => {
    setModalType(null);
    setShowModal(false);
  };

  const handleAssigneeChange = (event) => {
    console.log("event>>", event.target.value);
    setSelectedAssignee(Number(event.target.value));
    console.log("selectedAssignee", selectedAssignee);
  };
  const handleAssign = async () => {
    const assigneeId = selectedAssignee;
    console.log("assigneeId", assigneeId, modalType, selectedLeadId);
  
    if (!assigneeId) {
      toastError("Invalid assignee selected.");
      return;
    }
  
    // Confirmation alert before assigning the lead
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to assign this lead?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axiosInstance.post(
            "/presale/assignlead",
            {
              assigntype: modalType.toLowerCase().replace(" ", ""),
              [`${modalType.toLowerCase().replace(" ", "")}_id`]: assigneeId,
              lead_id: String(selectedLeadId),
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
              },
            }
          );
  
          // Success SweetAlert
          Swal.fire({
            title: "Success",
            text: "Lead assigned successfully!",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            callListApi(); // Reload the page after success
            setShowModal(false); // Close modal after assignment
          });
  
        } catch (error) {
          const errorMessage =
            error.response?.data?.message ||
            "Failed to assign lead. Please try again.";
  
          // Error SweetAlert
          Swal.fire({
            title: "Error",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      } else {
        console.log("Lead assignment cancelled by the user.");
      }
    });
  };

  const handleSearchChange = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchTerm(value);
    const filteredList = assigneeList.filter((assignee) =>
      assignee.name.toLowerCase().includes(value)
    );
    setFilteredAssigneeList(filteredList);
  };

  const handleMoreActions = (lead_code, lead_id, telecaller_id) => {
    setMoreActionsRowId(moreActionsRowId === lead_code ? null : lead_code);
    setSelectedLeadId(lead_id);
    setCurrentTelecallerId(telecaller_id);
  };

  const handleOpenModal = async (type) => {
    // fetchAssigneeList();
    setModalType(type);
    try {
      const endpoint =
        type === "Telecaller" ? "/user/ddltelecaller" : "/dealer/ddlDealer";
      const response = await axiosInstance.post(
        endpoint,
        {
          business_partner_id:
            businessPartnerId === "0" ? null : businessPartnerId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      const assignees = response.data.data.data.map((assignee) => ({
        name: assignee.NAME,
        id: assignee.ID,
        assignedLeads: assignee.assignedcount,
      }));
      setAssigneeList(assignees);
      console.log("assignees", assignees);
      setFilteredAssigneeList(assignees);
      //setModalType(null)
      console.log("filteredAssigneeList", filteredAssigneeList);
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        "Failed to fetch assignees. Please try again.";
      toastError(errorMessage);
      console.error("Error fetching assignees:", error);
    }
    setShowModal(true);
  };

  const handleEditDetails = () => {
    if (isFollowUp) {
      navigate(ROUTES_NAVIGATION.FOLLOWUPREQUIREDDETAILS, {
        state: { data: selectedLeadId },
      });
    }
    if (isLeadCalling) {
      navigate(ROUTES_NAVIGATION.FOLLOWUPREQUIREDDETAILS, {
        state: { data: selectedLeadId },
      });
    }
    if (isFollowUpRequired) {
      navigate(ROUTES_NAVIGATION.FOLLOWUPREQUIREDDETAILS, {
        state: { data: selectedLeadId },
      });
    }
    if (isOldLeadCalling) {
      navigate(ROUTES_NAVIGATION.FOLLOWUPREQUIREDDETAILS, {
        state: { data: selectedLeadId },
      });
    }
  };

  const offset = currentPage * itemsPerPage;
  const currentPageData = data.slice(offset, offset + itemsPerPage);

  const assigneeTypeFilter =
    modalType === "Telecaller" ? "Telecaller" : "Sales Manager";
  const filteredAssignees = assigneeList.filter((assignee) =>
    assignee.name.includes(assigneeTypeFilter)
  );
  console.log("currentPageData", currentPageData);

  const getStatusClass = (status) => {
    switch (status) {
      case "Pending":
        return "status-pending";
      case "In Progress":
        return "status-inprogress";
      case "Completed":
        return "status-completed";
      default:
        return "";
    }
  };

  const getStartIndex = () => {
    return currentPage * itemsPerPage + 1;
  };

  const getEndIndex = () => {
    return Math.min((currentPage + 1) * itemsPerPage, totalRecords);
  };
  const moreActionsRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        moreActionsRef.current &&
        !moreActionsRef.current.contains(event.target)
      ) {
        setMoreActionsRowId(null); 
      }
    };

    // Add the event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Clean up the event listener on unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [moreActionsRowId]);
  const visiblePages = 5; // Number of visible page buttons
  const startPage = Math.max(0, currentPage - Math.floor(visiblePages / 2));
  const endPage = Math.min(totalPages - 1, startPage + visiblePages - 1);

  return (
    <div className="table-container">
      <div className="scroll-container" style={{minHeight:totalRecords>0?200:0}}>
        <table className="reusable-table">
          <thead>
            <tr>
              {headers.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr key={row.id}>
                {headers.map((header, colIndex) => {
                  const key = keyMapping[header];

                  if (header === "Action") {
                    return (
                      <td key={colIndex} className="tbl-action-buttons">
                        {key.map((action, actionIndex) => (
                          <img
                            key={actionIndex}
                            src={action.icon}
                            height={20}
                            width={24}
                            alt={action.label}
                            onClick={() => {
                              if (action.type === "edit") {
                                onEdit(row);
                              } else if (action.type === "view") {
                                // handleView(row.id);
                              } else if (action.type === "more") {
                                handleMoreActions(
                                  row.lead_code,
                                  row.lead_id,
                                  row.telecaller_id
                                );
                              }
                            }}
                            className="action-icon"
                          />
                        ))}
                        {moreActionsRowId === row.lead_code && (
                          <div
                            ref={moreActionsRef}
                            className="additional-actions"
                          >
                            <span
                              className="action-span-presale"
                              onClick={() => handleOpenModal("Telecaller")}
                            >
                              Assign Telecaller
                            </span>
                            {/* <span
                              className="action-span-presale"
                              onClick={() => handleOpenModal("Sales Manager")}
                            >
                              Assign Sales Manager
                            </span> */}
                            <span
                              className="action-span-presale"
                              onClick={handleEditDetails}
                            >
                              View Details
                            </span>
                            <span
                              className="action-span-presale"
                              onClick={() => console.log("Call Now")}
                            >
                              Call Now
                            </span>
                          </div>
                        )}
                      </td>
                    );
                  }

                  if (header === "Allocate") {
                    const checkboxIndex = offset + rowIndex;
                    return (
                      <td key={colIndex}>
                        <input
                          type="checkbox"
                          checked={checkboxState[checkboxIndex]}
                          onChange={() => handleCheckboxChange(checkboxIndex)}
                        />
                      </td>
                    );
                  }

                  if (header === "Lead Priority") {
                    return (
                      <td key={colIndex} className="">
                        <span
                          className={
                            row[key] === "Warm Leads"
                              ? "warmLeads"
                              : row[key] === "Hot Leads"
                              ? "hotLeads"
                              : row[key] === "Cold Leads"
                              ? "coldLeads"
                              : ""
                          }
                        >
                          {row[key]}
                        </span>
                      </td>
                    );
                  }

                  if (header === "Status") {
                    return (
                      <td key={colIndex}>
                        <span className={getStatusClass(row[key])}>
                          {row[key]}
                        </span>
                      </td>
                    );
                  }

                  return <td key={colIndex}>{row[key]}</td>;
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0px 20px",
          width: "100%",
        }}
      >
        <div className="totalDataCounts">
          {totalRecords > 0
            ? `Showing ${getStartIndex()} to ${getEndIndex()} of Total ${totalRecords} Records`
            : "No records found"}
        </div>
        <div className="pagination">
          {totalRecords > 0 ? (
            <>
              <FaChevronLeft
                onClick={handlePreviousPage}
                className={
                  currentPage === 0
                    ? "pagination-icon disabled"
                    : "pagination-icon"
                }
              />
              <div className="pagination-btns">
                {startPage > 0 && (
                  <span
                    onClick={() => handlePageClick(0)}
                    className="pagination-btn"
                  >
                    1
                  </span>
                )}
                {startPage > 1 && <span className="pagination-btn">...</span>}
                {Array.from({ length: endPage - startPage + 1 }, (_, index) => (
                  <span
                    key={startPage + index}
                    onClick={() => handlePageClick(startPage + index)}
                    className={
                      currentPage === startPage + index
                        ? "pagination-btn pagination-active"
                        : "pagination-btn"
                    }
                  >
                    {startPage + index + 1}
                  </span>
                ))}
                {endPage < totalPages - 2 && (
                  <span className="pagination-btn">...</span>
                )}
                {endPage < totalPages - 1 && (
                  <span
                    onClick={() => handlePageClick(totalPages - 1)}
                    className="pagination-btn"
                  >
                    {totalPages}
                  </span>
                )}
              </div>
              <FaChevronRight
                onClick={handleNextPage}
                className={
                  currentPage === totalPages - 1
                    ? "pagination-icon disabled"
                    : "pagination-icon"
                }
              />
            </>
          ) : (
            ""
          )}
        </div>
      </div>
      {isallocation && (
        <div style={{ textAlign: "right" }}>
          <button
            ref={assignButtonRef}
            onClick={handleAssignClick}
            className="assign-button"
          >
            Assign To
          </button>
        </div>
      )}

      {showModal && (
        <Modal
          isPresales={true}
          show={showModal}
          handleClose={handleModalClose}
          position={modalPosition}
          centered
        >
          <span className="modalheading">Select {modalType}</span>
          <input
            type="text"
            placeholder="Search Assignee"
            className="leadmodalsearch mt-2 mb-2"
            value={searchTerm}
            onChange={handleSearchChange}
          />
          <div className="assignee-list">
            {filteredAssigneeList.map((assignee, index) => (
              <div key={index} className="assignee-item mt-2">
                <label htmlFor={`assignee-${index}`}>{assignee.name}</label>
                <div className="countcontainer">
                  <label htmlFor={`assignee-${index}`} className="counttotal">
                    {" "}
                    {assignee.assignedLeads} leads Assigned
                  </label>
                  <input
                    type="radio"
                    style={{ height: 20, width: 20 }}
                    name="assignee"
                    value={assignee.id}
                    onChange={handleAssigneeChange}
                    checked={selectedAssignee === assignee.id}
                    // checked={assignee.id === currentTelecallerId?currentTelecallerId:selectedAssignee}
                  />
                </div>
              </div>
            ))}
          </div>
          <div className="modalbuttons mt-2">
            <button className="leadbtn" onClick={handleAssign}>
              Assign
            </button>
            <button className="leadbtn" onClick={handleModalClose}>
              Cancel
            </button>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default ReusableTable;
